module.exports = __webpack_public_path__ + "img/mtstudio.d80b685e.jpg";